import {
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  SET_REFERRAL_CODE_VALIDITY_STATUS,
  VALIDATE_REFERRAL_CODE,
} from "./actionTypes"

export const registerUser = (user, history) => {
  return {
    type: REGISTER_USER,
    payload: { user, history },
  }
}

export const registerUserSuccessful = user => {
  return {
    type: REGISTER_USER_SUCCESSFUL,
    payload: user,
  }
}

export const registerUserFailed = user => {
  return {
    type: REGISTER_USER_FAILED,
    payload: user,
  }
}

export const validateReferralCode = resp => {
  return {
    type: VALIDATE_REFERRAL_CODE,
    payload: resp,
  }
}

export const setReferralCodeValidity = resp => {
  return {
    type: SET_REFERRAL_CODE_VALIDITY_STATUS,
    payload: resp,
  }
}
